module.exports = "https://static.wmbcdn.com/uniweb/images/1d2a94b8cb61ff581511404506d5d79c.svg";